import styled, {css} from "styled-components";

interface OntarioSafeToPlayButtonBoxProps {
    isShownInHeader: boolean
}

export const OntarioSafeToPlayButtonBox = styled.button<OntarioSafeToPlayButtonBoxProps>`
    width: 175px;
    height: 35px;
    background-image: url("${props => props.theme.images.regulationSpecific.ontario.safeToPlayButton.toString()}");
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    ${props => !props.isShownInHeader && css`background-position: center center`}
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      height: 25px;
    }
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        background-position: center center
    }
`